<div class="columns is-gapless is-desktop is-vcentered login-container" style="padding: 3vh 3vw;">
  <!-- Left Side (Desktop Only) -->
  <div class="column is-8 is-hidden-touch left-side">
    <div class="content-wrapper">
      <img src="logo_black.svg" alt="Besedan Logo" class="logo">

      <div class="text-content">
        <h1 class="title is-1 mb-2 has-text-white">
          {{ 'authLayout.title' | translate }}
        </h1>
        <p class="subtitle is-6 has-text-white">{{ 'authLayout.subtitle' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Right Side (Content) -->
  <div class="column is-4 is-two-thirds-tablet is-full-touch right-side p-6">
    <div class="mobile-logo is-hidden-desktop has-text-centered mb-6">
      <img src="logo_white.svg" alt="Besedan Logo" class="mobile-logo-img">
    </div>

    <div class="card login-card">
      <div class="m-4 is-flex is-justify-content-flex-end">
        <app-language-selector-input [languageCode]="languageCode$ | async " (languageCodeChange)="onLanguageChange($event)" />
      </div>
      <div class="card-content">

        @if (title) {
        <h2 class="title has-text-black is-3 has-text-centered mb-5">{{ title }}</h2>
        }
        @if (subtitle) {
        <p class="subtitle is-6 has-text-centered mb-5">{{ subtitle }}</p>
        }

        <ng-content></ng-content>
      </div>
      <div class="m-4 is-flex is-justify-content-flex-end" style="visibility: hidden;">
        <app-language-selector-input />
      </div>
    </div>
  </div>
</div>